import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route,Switch } from 'react-router-dom';
import Layout from '../../../Layout/index';
import DefaultPages from './DefaultPages';
import Account from './Account';

import Maps from './Maps';
import Charts from './Charts';
import Tables from './Tables';
import Forms from './Forms';
import Settings from './Settings';
import Inference from './Inference';

import LogIn from '../../../Account/LogIn/index';

import Todo from '../../../Todo/index';

import AssetsDashboard from '../../../Dashboards/Assets/index';
import ProcessesDashboard from '../../../Dashboards/Processes/index';
import AssetEvents from '../../../Events/AssetEvents/index';
import EditFeedbackReport from '../../../Health/AssetHealth/components/EditFeedbackReport';
import ComponentFeedbackReport from '../../../Health/AssetHealth/components/ComponentFeedbackReport';
import ProcessEvents from '../../../Events/ProcessEvents/index';
import EventFeedbackReport from '../../../Events/AssetEvents/components/EventFeedbackReport';

import AssetHealth from '../../../Health/AssetHealth/index';
import ProcessHealth from '../../../Health/ProcessHealth/index';

class WrappedRouter extends Component {
  render() {
    const { token } = this.props;
    return (
      <div>
        <Layout />
        <div className="container__wrap">
          <Switch>
              <Route exact path="/" component={AssetsDashboard} />
              <Route path="/dashboard_assets" component={AssetsDashboard} />
              <Route path="/dashboard_events" component={AssetEvents} />
              <Route path="/dashboard_health" component={AssetHealth} />
              <Route path="/dashboard_processes" component={ProcessesDashboard} />
              <Route path="/asset_events" component={AssetEvents} />
              <Route path="/asset_health_report" component={ComponentFeedbackReport} />
              <Route path="/event_feedback_report" component={EventFeedbackReport} />
              <Route path="/process_events" component={ProcessEvents} />
              <Route path="/asset_health" component={AssetHealth} />
              <Route path="/process_health" component={ProcessHealth} />
              <Route path="/account" component={Account} />
              <Route path="/settings" component={Settings} />
              <Route path="/inference" component={Inference} />

              <Route path="/todo" component={Todo} />
              <Route path="/forms" component={Forms} />
              <Route path="/tables" component={Tables} />
              <Route path="/charts" component={Charts} />
              <Route path="/maps" component={Maps} />
              <Route path="/default_pages" component={DefaultPages} />
          </Switch>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ token }) {
  return {
    token
  };
}

export default connect(mapStateToProps, null)(WrappedRouter);
